module.exports = __webpack_public_path__ + "static/media/facebook-logo.f2b3fd1a.svg";